import React, { useState } from 'react';
import { Popover } from '@mui/material';
import { Loader } from 'components';
import { Svg } from 'assets';

export const Settings = (
  {
    list = [],
    className,
    loading,
    MainSvg,
    MainComponent,
    mainLoaderStyles = {},
    itemStyles = {},
    onClick,
  }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentItemIndex, setCurrentItemIndex] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const toggleMenu = (event) => {
    if (event && !!list?.length) {
      setAnchorEl(event?.currentTarget);
    } else {
      setAnchorEl(null);
      setCurrentItemIndex(null);
    }

    if (onClick && !list?.length) {
      onClick(event);
    }
  };

  return (
    <div className={`settings-wrapper ${className ? className : ''}`}>
      <div className={'settings-icon-wrapper'} onClick={toggleMenu}>
        {MainComponent ?
          MainComponent
          :
          loading ?
            <Loader styles={{ color: '#0948A1', width: 20, height: 20, mainLoaderStyles }} />
            :
            MainSvg ?
              <MainSvg className={'settings-icon-svg-main'} />
              :
              <Svg.Eye className={'settings-icon-svg-eye'} />
        }
      </div>

      {(!!list?.length) && (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={() => toggleMenu()}
          className={'settings-menu'}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          {list?.filter((listItem) => listItem)?.map(({ Svg, text, handleClick, loadingItem }, index) => (
            <div
              key={index}
              className='settings-item-wrapper'
              onClick={(e) => {
                setCurrentItemIndex(index);

                if (handleClick) {
                  handleClick(toggleMenu, e);
                }
              }}
              style={{ ...itemStyles }}
            >
              {text && <p className='settings-text'>{text}</p>}
              {Svg &&
                <div className='settings-item-svg'>
                  {loadingItem && currentItemIndex === index ?
                    <Loader styles={{ color: '#347AF0', width: '100%', height: '100%', mainLoaderStyles }} />
                    : Svg && <Svg />
                  }
                </div>
              }
            </div>
          ))}
        </Popover>
      )}
    </div>
  );
};
